var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncognitoBrowserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C2.89543 3 2 3.89543 2 5V6.25H22V5C22 3.89543 21.1046 3 20 3H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.75H2V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V7.75ZM8.15 12.25L8.61203 9.93986C8.71711 9.41447 9.21761 9.06525 9.74698 9.14797L12 9.5L14.253 9.14797C14.7824 9.06525 15.2829 9.41447 15.388 9.93986L15.85 12.25H17C17.4142 12.25 17.75 12.5858 17.75 13C17.75 13.4142 17.4142 13.75 17 13.75H7C6.58579 13.75 6.25 13.4142 6.25 13C6.25 12.5858 6.58579 12.25 7 12.25H8.15ZM11.3546 17.25C11.0579 17.983 10.3393 18.5 9.5 18.5C8.39543 18.5 7.5 17.6046 7.5 16.5C7.5 15.3954 8.39543 14.5 9.5 14.5C10.3393 14.5 11.0579 15.017 11.3546 15.75H12.6454C12.9421 15.017 13.6607 14.5 14.5 14.5C15.6046 14.5 16.5 15.3954 16.5 16.5C16.5 17.6046 15.6046 18.5 14.5 18.5C13.6607 18.5 12.9421 17.983 12.6454 17.25H11.3546Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoBrowserAlt);
export default __webpack_public_path__ + "static/media/incognito-browser-alt.3baae8f971086293cd6e59c003e49f84.svg";
export { ForwardRef as ReactComponent };